/**
 * size values
 */
export const sizes = { xs: "xs", s: "s", m: "m", l: "l" }

export const qualifierSVGSizes = {
  xs: { height: "12", width: "12" },
  sm: { height: "14", width: "14" },
  md: { height: "16", width: "16" },
  lg: { height: "16", width: "16" },
}

export const iconSVGSizes = {
  xs: { height: "12", width: "12" },
  sm: { height: "14", width: "14" },
  md: { height: "16", width: "16" },
  lg: { height: "18", width: "18" },
}
